<div class="status-label" [ngStyle]="{ 'backgroundColor' : statusColor ? statusColor : 'transparent' }">
  <span [ngStyle]="{ 'color' : textColor ? textColor : '#000'}">{{ status }}</span>
</div>
